import { toast as sonnerToast } from "sonner";

export const toast = {
  success: (msg: string): void => void sonnerToast.success(msg, { duration: 5000 }),
  info: (msg: string): void => void sonnerToast(msg, { duration: 5000 }),
  warn: (msg: string): void => void sonnerToast.warning(msg, { duration: 7000 }),
  error: (msg: string, opts?: { multiline?: boolean }): void =>
    void sonnerToast.error(msg, {
      duration: 8000,
      closeButton: true,
      ...(opts?.multiline ? { className: "whitespace-pre-line" } : {}),
    }),
};
